export const darkTheme = {
  backgroundColor: "145deg, #1e1928, #2a253a",
  darkColor: "#1e1928",
  textColor: "#9290cc",
  shadowColorOne: "#171420",
  shadowColorTwo: "#312a42",
  boxShadow: "30px 30px 58px #171420,-30px -30px 58px #312a42",
  buttonShadow: "inset 30px 30px 35px #191522, inset -30px -30px 35px #2F2940",
  buttonHoverShadow:
    "inset 30px 30px 50px #191522, inset -30px -30px 50px #2F2940",
  iconSize: 1.5,
  iconShadow: "11.71px 10px 13px #171420, -10px -11.71px 13px #312A42",
  iconShadowHover: "11.71px 20px 13px #171420, -20px -11.71px 13px #312A42",
  iconBackgroundColor: "#241f31",
  inputFieldShadow:
    "inset 12.31px 12.31px 18px #1F1B2A, inset -12.31px -12.31px 88px #292338",
  checkboxShadow: "inset 2px 2px 3px #654da1, inset -2px -2px 3px #191522",
  checkboxShadowChecked: "5px 5px 10px #171420, -5px -5px 10px #312a42",
  checkboxBackgroundColor: "#7473b0",
};

export const lightTheme = {
  backgroundColor: "145deg, #7473b0, #a09ff4",
  darkColor: "#7473b0",
  textColor: "#3d3c5a",
  shadowColorOne: "#595887",
  shadowColorTwo: "#bbbaff",
  boxShadow: "20px 20px 50px #595887,-20px -20px 50px #bbbaff",
  buttonShadow: "inset 5px 5px 30px #5f5f91, inset -10px -10px 30px #b5b3ff",
  buttonHoverShadow:
    "inset 5px 5px 40px #5f5f91, inset -10px -10px 40px #b5b3ff",
  iconSize: 1.5,
  iconShadow: "10px 10px 15px #7574b1, -10px -10px 15px #9f9ef3",
  iconShadowHover: "10px 10px 20px #7574b1, -10px -10px 20px #9f9ef3",
  iconBackgroundColor: "#8a89d2",
  inputFieldShadow:
    "inset 12.31px 12.31px 18px #7675b4, inset -12.31px -12.31px 18px #9e9df0",
  checkboxShadow:
    "inset 2.31px 2.31px 2px #7675b4, inset -2.31px -2.31px 2px #9e9df0",
  checkboxShadowChecked: "5px 5px 10px #7574b1, -5px -5px 10px #9f9ef3",
  checkboxBackgroundColor: "#7473b0",
};
